<mat-card class="mat-card profile-card">
  <div class="row" fxLayoutAlign="space-between center">
    <h2 class="card-title">
      {{ '365-USER-PAGE.CARD-TITLE.LICENSES-TITLE' | translate }}
    </h2>
    <img
      src="../../../assets/images/maintenance/services/ENTRA.svg"
      class="indices"
      alt="{{ 'GENERAL.SERVICE_IMAGE' | translate }}" />
  </div>
  @if (userLicenses) {
    @if (userLicenses.length > 0) {
      <div class="search-section">
        <div class="search-field">
          <div class="search-wrapper">
            <div
              class="search"
              fxFlex
              fxLayout="row"
              fxLayoutAlign="start center">
              <mat-icon>search</mat-icon>
              <input
                autoComplete="on"
                #filter
                [formControl]="licensesNameFilter"
                matInput
                placeholder="{{
                  '365-USER-PAGE.LICENSES.SEARCH-NAME-FIELD' | translate
                }}" />
            </div>
          </div>
          <!-- <div 
                    class="checkbox-field"
                    fxLayout="row">
                        <div 
                        fxFlex
                        fxLayout="column" 
                        class="userTypeFilter">
                            <mat-checkbox [formControl]="licensesHasConflictFilter" class="form-text">
                                {{ '365-USER-PAGE.LICENSES.CONFLICT' | translate}}
                            </mat-checkbox>
                        </div>
                    </div>-->
        </div>
      </div>
      <table
        [hidden]="dataSourceLicenses.filteredData.length === 0"
        mat-table
        matSort
        [dataSource]="dataSourceLicenses">
        <ng-container matColumnDef="photo">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let license">
            <img
              src="../../../../assets/images/maintenance/services/ENTRA.svg"
              class="serviceImage"
              alt="{{ 'GENERAL.SERVICE_IMAGE' | translate }}" />
          </td>
        </ng-container>

        <ng-container matColumnDef="displayName">
          <th mat-header-cell *matHeaderCellDef>
            {{ '365-USER-PAGE.LICENSES.NAME' | translate }}
          </th>
          <td mat-cell *matCellDef="let license">{{ license.displayName }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>
            {{ '365-USER-PAGE.LICENSES.STATUS' | translate }}
          </th>
          <td mat-cell *matCellDef="let license">-</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsLicenses"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumnsLicenses"></tr>
      </table>
      @if (dataSourceLicenses.filteredData.length === 0) {
        <h1 class="no-item">
          {{ '365-USER-PAGE.LICENSES.NOTHING-FILTERED' | translate }}
        </h1>
      }
      <div [hidden]="isBusy || dataSourceLicenses.filteredData.length === 0">
        <mat-paginator
          class="paginator"
          [pageSize]="5"
          [hidePageSize]="true"
          showFirstLastButtons>
        </mat-paginator>
      </div>
    } @else {
      <h1 class="no-item">
        {{ '365-USER-PAGE.LICENSES.NOTHING' | translate }}
      </h1>
    }
  } @else {
    <div class="general-container" fxLayout="row" fxLayoutAlign="center center">
      <mat-progress-spinner
        [color]="spinner.color"
        [mode]="spinner.mode"
        [value]="spinner.value"
        [diameter]="spinner.diameter">
      </mat-progress-spinner>
    </div>
  }
</mat-card>
